import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"

export default () => {
    return (
        <Layout>
            <SEO title="Contact Us" />
            <div className="container text-center">
                <h1>Contact Us</h1>
            </div>
            <div className="row">
                <div className="col-md text-center">
                    <h2>Send us a message</h2>
                    <form name="contact" method="post" data-netlify="true">
                        <p>
                            <label>Name: <input type="text" name="name" /></label>
                        </p>
                        <p>
                            <label>Email: <input type="email" name="email" /></label>
                        </p>
                        <p>
                            <label>Message: <textarea name="message"></textarea></label>
                        </p>
                        <p>
                            <button type="submit">Send</button>
                        </p>
                    </form>
                </div>
                <div className="col-md text-center text-md-left">
                    <h2>Getting in touch</h2>
                    <p>Email: thrivingmadly@gmail.com</p>
                    <p>Phone: 0212277881</p>
                </div>
            </div>
        </Layout>
    )
}